module.exports = __webpack_public_path__ + "img/video-pause.61f96336.svg";